export default "__VITE_ASSET__C8_7QjMI__"